import { useEffect } from "react";
import { useForm } from "react-final-form";
import BasicAccordion from "components/basic/BasicAccordion";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import DateInput from "components/form/input/DateInput";
import SelectInput from "components/form/input/SelectInput";
import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import Equipamento from "entity/Equipamento";
import TalhaoSelect from "entity/Fazenda/components/TalhaoSelect";
import Frente from "entity/Frente";
import Implemento from "entity/Implemento";
import Trator from "entity/Trator";
import Variedade from "entity/Variedade";
import { CORTE_OPTIONS } from "entity/Indicador/components/apontamento/fields/corteOptions";
import { buildTalhoesComVariedadeAtualizada } from "entity/Indicador/components/apontamento/fields/variedadeSync";

export default function ApontamentoCommonFields({
    visita,
    TipoClass,
    showTalhao = true,
    showTrator = true,
    showImplemento = true,
    showFrente = true,
    showEquipamento = false,
    showVariedade = false,
    showCorte = false,
    defaultExpanded = true,
}) {
    const [frente] = useFieldValue("frenteObj");
    const [talhao] = useFieldValue("talhao");
    const [variedade] = useFieldValue("variedade");
    const form = useForm();

    useEffect(() => {
        if (!showVariedade || variedade) return;

        const talhaoUnico = Array.isArray(talhao) ? talhao[0] : talhao;
        if (talhaoUnico?.variedade) {
            form.change("variedade", talhaoUnico.variedade);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showVariedade, talhao]);

    useEffect(() => {
        if (!showVariedade || TipoClass?.field !== "plantio" || !variedade) return;

        const talhaoUnico = Array.isArray(talhao) ? talhao[0] : talhao;
        const talhoesFazenda = visita.fazenda?.data?.talhoesFazenda;
        const novosTalhoes = buildTalhoesComVariedadeAtualizada(talhoesFazenda, talhaoUnico?.uid, variedade);
        if (novosTalhoes === talhoesFazenda) return;

        visita.fazenda.update({ talhoesFazenda: novosTalhoes });
        visita.fazenda.save();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showVariedade, TipoClass, talhao, variedade]);

    return (
        <BasicAccordion title="Dados Básicos" defaultExpanded={defaultExpanded} fullWidth disableGutters>
            <FormContent>
                <FormRow>
                    <DateInput showTime name="date" label="Data / Hora Coleta" disabled />
                </FormRow>

                {showTalhao ? (
                    <FormRow>
                        {/* TODO (2259): 7º passo */}
                        <TalhaoSelect
                            name="talhao"
                            label="Talhão"
                            fazenda={visita.fazenda}
                            // multiple={talhaoMultiple}
                            required
                        />
                    </FormRow>
                ) : null}

                {showTrator ? (
                    <FormRow>
                        <EntitySearchInput
                            name="trator"
                            label="Trator"
                            EntityClass={Trator}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                            required
                        />
                    </FormRow>
                ) : null}

                {showImplemento ? (
                    <FormRow>
                        <EntitySearchInput
                            name="implemento"
                            label="Implemento"
                            EntityClass={Implemento}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                            required
                        />
                    </FormRow>
                ) : null}

                {showFrente ? (
                    <FormRow>
                        <EntitySearchInput
                            name="frenteObj"
                            label="Frente"
                            EntityClass={Frente}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                            required
                        />

                        {/* Opted to create this invisible input that takes the frenteObj reference and use its value as initial */}
                        <TextInput name="frente" initialValue={frente?.frente} sx={{ display: "none" }} />
                    </FormRow>
                ) : null}

                {showEquipamento ? (
                    <FormRow>
                        <EntitySearchInput
                            name="equipamento"
                            label="Equipamento"
                            EntityClass={Equipamento}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                            // required
                        />
                    </FormRow>
                ) : null}

                {showVariedade ? (
                    <FormRow>
                        <EntitySearchInput name="variedade" label="Variedade" EntityClass={Variedade} />
                    </FormRow>
                ) : null}

                {showCorte ? (
                    <FormRow>
                        <SelectInput name="corte" label="Corte" options={CORTE_OPTIONS} />
                    </FormRow>
                ) : null}
            </FormContent>
        </BasicAccordion>
    );
}
